import React from "react";
import { CIBLES } from "@/constants/testIds";
import { Briefcase, Home, Check } from "lucide-react";

const B2B_IMG =
  "https://images.pexels.com/photos/7698712/pexels-photo-7698712.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
const B2C_IMG =
  "https://images.unsplash.com/photo-1613490493576-7fde63acd811";

const b2b = [
  "Prévoyance et santé collectives (ANI, Madelin, Loi Fillon)",
  "Homme-clé, croisée entre associés, garantie de passif",
  "Multirisque professionnelle & RC pro sectorielle",
  "Cyber-risques, fraude et interruption d'activité",
  "Flottes automobiles et responsabilités du dirigeant",
];

const b2c = [
  "Assurance vie & PER individuel — allocations pilotées",
  "Prévoyance famille : décès, invalidité, dépendance",
  "Complémentaire santé haut de gamme",
  "Emprunteur — délégation & renégociation",
  "Multirisque habitation résidence principale et secondaire",
];

export default function Cibles() {
  return (
    <section
      id="cibles"
      data-testid={CIBLES.root}
      className="relative py-24 md:py-32 bg-white border-y border-[#0a192f]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#c05c3d]" />
              <span className="overline">À qui nous nous adressons</span>
            </div>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] text-[#0a192f]">
              Dirigeants d&apos;abord.<br />
              <span className="italic">Familles ensuite.</span>
            </h2>
          </div>
          <p className="max-w-md text-[#475569] leading-relaxed">
            Nous consacrons l&apos;essentiel de notre temps aux entreprises — parce
            qu&apos;un dirigeant bien protégé protège aussi les siens.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Entreprises card */}
          <article
            data-testid={CIBLES.cardEntreprises}
            className="relative lg:col-span-7 overflow-hidden text-[#efeade] p-10 md:p-14 min-h-[520px] flex flex-col justify-between"
          >
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${B2B_IMG})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-br from-[#0a192f]/95 via-[#0a192f]/80 to-[#0a192f]/40" />
            <div className="absolute inset-0 grain opacity-30" />

            <div className="relative">
              <div className="flex items-center gap-3">
                <Briefcase size={22} strokeWidth={1.25} className="text-[#b08d57]" />
                <span className="overline text-[#b08d57]">Cœur de métier</span>
              </div>
              <h3 className="mt-8 font-serif text-4xl md:text-5xl leading-tight">
                Entreprises & Dirigeants
              </h3>
              <p className="mt-5 max-w-lg text-[#efeade]/80 leading-relaxed">
                Nous concevons des architectures d&apos;assurance globales pour PME
                et ETI. Un interlocuteur unique, une revue annuelle, des
                arbitrages documentés.
              </p>
            </div>

            <ul className="relative mt-10 space-y-3">
              {b2b.map((s, i) => (
                <li key={i} className="flex items-start gap-3 text-sm md:text-[15px] text-[#efeade]/90">
                  <Check size={16} strokeWidth={1.5} className="mt-1 text-[#c05c3d] shrink-0" />
                  <span>{s}</span>
                </li>
              ))}
            </ul>
          </article>

          {/* Particuliers card */}
          <article
            data-testid={CIBLES.cardParticuliers}
            className="relative lg:col-span-5 bg-[#efeade] p-10 md:p-14 min-h-[520px] flex flex-col justify-between border border-[#0a192f]/10"
          >
            <div>
              <div className="flex items-center gap-3">
                <Home size={22} strokeWidth={1.25} className="text-[#c05c3d]" />
                <span className="overline">Sur invitation</span>
              </div>
              <h3 className="mt-8 font-serif text-4xl md:text-5xl leading-tight text-[#0a192f]">
                Particuliers <span className="italic">exigeants</span>
              </h3>
              <p className="mt-5 max-w-md text-[#475569] leading-relaxed">
                Une clientèle de dirigeants, professions libérales et familles
                patrimoniales. Chaque dossier étudié par un associé.
              </p>
            </div>

            <div className="mt-10">
              <div
                className="w-full h-40 mb-8 bg-cover bg-center"
                style={{ backgroundImage: `url(${B2C_IMG})` }}
              />
              <ul className="space-y-3">
                {b2c.map((s, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm md:text-[15px] text-[#0a192f]">
                    <Check size={16} strokeWidth={1.5} className="mt-1 text-[#c05c3d] shrink-0" />
                    <span>{s}</span>
                  </li>
                ))}
              </ul>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
